// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const supplierLocationOperations = {
  getSuppliersOld: ['get', '/suppliers'] as const,
  retrieveSupplierListOld: ['post', '/suppliers'] as const,
  getSuppliers: ['get', '/supplier/location'] as const,
  retrieveSupplierList: ['post', '/supplier/location'] as const,
  getAllSuppliers: ['get', '/supplier/location/all'] as const,
  getHealth: ['get', '/health'] as const
} as const;
